module.exports = __webpack_public_path__ + "img/carte-vitale.6c77865e.svg";